<template>
  <NormalSelect
    :selected="_fontSize"
    :options="options"
    :optionValue="'value'"
    :optionLabel="'text'"
    :menuDrop="menuDrop"
    :menuMaxWidth="menuMaxWidth"
    :menuMaxHeight="menuMaxHeight"
    :boundary="boundary"
    :block="block"
    :notMatchDefault="_notMatchDefault"
    @change="onChange"
  />
</template>

<script>
import NormalSelect from "@components_system/Shared/Tools/NormalSelect/NormalSelect";
import { getFontSizes } from '@model/masterData';

export default {
  components: {
    NormalSelect,
  },
  props: {
    fontSize: {
      // type: String,
      // default: null,
    },
    optionSize: {
      type: String,
      default: "default",   // "header", "footer", "heading1", "heading2", "heading3", "heading4", "paragrapg", "link", "default"
    },
    menuDrop: {
      type: String,
      default: undefined,
    },
    menuMaxWidth: {
      type: String,
      default: undefined,
    },
    menuMaxHeight: {
      type: String,
      default: undefined,
    },
    boundary: {
      type: String,
      default: undefined,
    },
    block: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    options() {
      return this.optionSize == "header" ? getFontSizes('8_30')
        : this.optionSize == "footer" ? getFontSizes('8_30')
        : this.optionSize == "footerTags" ? getFontSizes('8_24')
        : this.optionSize == "heading1" ? getFontSizes('16_200')
        : this.optionSize == "heading2" ? getFontSizes('16_200')
        : this.optionSize == "heading3" ? getFontSizes('8_200')
        : this.optionSize == "heading4" ? getFontSizes('8_200')
        : this.optionSize == "paragraph" ? getFontSizes('8_30')
        : this.optionSize == "link" ? getFontSizes('8_30')
        : this.optionSize == "button" ? getFontSizes('8_30')
        : this.optionSize == "productBadge" ? getFontSizes('8_18')

        : this.optionSize == "8_14" ? getFontSizes('8_14')
        : this.optionSize == "8_18" ? getFontSizes('8_18')
        : this.optionSize == "8_24" ? getFontSizes('8_24')
        : this.optionSize == "8_30" ? getFontSizes('8_30')
        : this.optionSize == "8_200" ? getFontSizes('8_200')
        : this.optionSize == "8_60" ? getFontSizes('8_60')
        : this.optionSize == "16_60" ? getFontSizes('16_60')
        : this.optionSize == "16_200" ? getFontSizes('16_200')

        : this.optionSize == "cms_8_14" ? getFontSizes('8_14')
        : this.optionSize == "cms_8_30" ? getFontSizes('8_30')
        : this.optionSize == "cms_16_200" ? getFontSizes('16_200')
        : getFontSizes();
    },
    size(){
      return Array.isArray(this.fontSize)
      ? `${this.fontSize[0]}`.replace("px", "")
      : `${this.fontSize}`.replace("px", "");

    },
    _fontSize() {
      const findFont = this.options.filter(
        (item) => this.size && item.value == this.size
      )[0];
      return findFont ? findFont.value : null;
    },
    _notMatchDefault() {
      const min = this.options[0].value;
      const max = this.options[this.options.length - 1].value;
      return Math.min(Math.max(this.size, min), max);
    }
  },
  methods: {
    onChange(value) {
      this.$emit("input", value);
      this.$emit("change", value);
      this.$emit("input:fontSize", value);
      this.$emit("change:fontSize", value);
      this.$emit("update:fontSize", value);
    },
  },
};
</script>

<style></style>
